module.exports = __webpack_public_path__ + "img/Jose_Diman_Lujan.2bc7b0e4.jpg";